import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

let bugsnagStarted = false

export async function init (vueReference) {
  try {
    const response = await fetch('/api/base/bugsnag-config')

    if (!response.ok) {
      console.error(`Bugsnag config fetch failed: server responded with ${response.status}`)
      return
    }

    const { data } = await response.json()
    const { apiKey, stage } = data || {}
    if (!apiKey) {
      return
    }

    Bugsnag.start({
      apiKey,
      plugins: [new BugsnagPluginVue()],
      releaseStage: stage || 'development',
      redactedKeys: [/password/i],
      onError: (event) => {
        const err = event.originalError
        // do not send network errors to Bugsnag
        if (err && (err.code === 'ERR_NETWORK' || err.isNetworkError)) {
          console.warn('Ignoring network error for Bugsnag:', err.message)
          return false // cancels sending the report
        }
        // prevent the 'dragging' error from being reported to Bugsnag.
        // this error originates from the 'leaflet.marker.slideto' plugin, which does not handle its internal errors properly.
        // as a result, the 'dragging' error cannot be caught on our side and ends up being sent to Bugsnag —
        // it accounts for the majority of the reported errors there.
        if (event.errors.some(e => e.errorMessage?.includes('dragging'))) {
          return false // cancels sending the report
        }
      }
    })

    Bugsnag.getPlugin('vue').installVueErrorHandler(vueReference)
    bugsnagStarted = true
  }
  catch (error) {
    console.error(error)
  }
}

export function notify (exception) {
  if (!bugsnagStarted) {
    console.warn('Bugsnag not initialized yet', exception)
    return
  }

  if (exception instanceof Error) {
    Bugsnag.notify(exception)
    return
  }

  if (exception == null) {
    console.warn('notify() called with nullish value — skipping Bugsnag report')
    return
  }

  const message = typeof exception === 'string' ? exception : JSON.stringify(exception)
  Bugsnag.notify(new Error(message))
}
